module.exports = __webpack_public_path__ + "img/frasco_inovah_1000.d4b4ff88.png";